import { Icon } from '@iconify/react/dist/iconify.js'
import React, { useState, useEffect } from 'react'
import useReactApexChart from '../../hook/useReactApexChart'

import { licenseMetrics } from '../../services/api'

const UnitCountTwo = () => {
    const [metrics, setMetrics] = useState({
        total_active_employees: 0,
        total_active_users: 0,
        total_active_companies: 0,
        total_max_employees: 0,
        total_max_users: 0,
        total_max_companies: 0
    });
    const [loading, setLoading] = useState(true);
    let { createChart } = useReactApexChart();

    useEffect(() => {
        const fetchMetrics = async () => {
            try {
                const response = await licenseMetrics();
                
                setMetrics({
                    total_active_employees: response.total_active_employees || 0,
                    total_active_users: response.total_active_users || 0,
                    total_active_companies: response.total_active_companies || 0,
                    total_max_employees: response.total_max_employees || 0,
                    total_max_users: response.total_max_users || 0,
                    total_max_companies: response.total_max_companies || 0
                });
            } catch (error) {
                console.error('Error fetching license metrics:', error);
                // Keep the default values (0) if there's an error
            } finally {
                setLoading(false);
            }
        };

        fetchMetrics();
    }, []);



    return (
        <div className="col-xxl-8">
            <div className="row gy-4">

                <div className="col-xxl-4 col-sm-6">
                    <div className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-1">
                        <div className="card-body p-0">
                            <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                                <div className="d-flex align-items-center gap-2">
                                    <span className="mb-0 w-48-px h-48-px bg-primary-600 flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6 mb-0">
                                        <Icon
                                            icon="mingcute:user-follow-fill"
                                            className="icon"
                                        />
                                    </span>
                                    <div>
                                        <span className="mb-2 fw-medium text-secondary-light text-sm">
                                            Total Active Employee
                                        </span>
                                        <h6 className="fw-semibold">
                                            {loading ? (
                                                <div className="spinner-border spinner-border-sm text-primary" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            ) : (
                                                metrics.total_active_employees.toLocaleString()
                                            )}
                                        </h6>
                                    </div>
                                </div>
                                <div
                                    id="new-user-chart"
                                    className="remove-tooltip-title rounded-tooltip-value"
                                >
                                    {/* Pass the color value here */}
                                    {createChart('#487fff')}

                                </div>

                            </div>
                            
                        </div>
                    </div>
                </div>

                <div className="col-xxl-4 col-sm-6">
                    <div className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-2">
                        <div className="card-body p-0">
                            <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                                <div className="d-flex align-items-center gap-2">
                                    <span className="mb-0 w-48-px h-48-px bg-success-main flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6">
                                        <Icon
                                            icon="mingcute:user-follow-fill"
                                            className="icon"
                                        />
                                    </span>
                                    <div>
                                        <span className="mb-2 fw-medium text-secondary-light text-sm">
                                            Total Active Users
                                        </span>
                                        <h6 className="fw-semibold">
                                            {loading ? (
                                                <div className="spinner-border spinner-border-sm text-success" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            ) : (
                                                metrics.total_active_users.toLocaleString()
                                            )}
                                        </h6>
                                    </div>
                                </div>
                                <div
                                    id="active-user-chart"
                                    className="remove-tooltip-title rounded-tooltip-value"
                                >
                                    {/* Pass the color value here */}
                                    {createChart('#45b369')}
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>

                <div className="col-xxl-4 col-sm-6">
                    <div className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-3">
                        <div className="card-body p-0">
                            <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                                <div className="d-flex align-items-center gap-2">
                                    <span className="mb-0 w-48-px h-48-px bg-yellow text-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                                        <Icon
                                            icon="iconamoon:discount-fill"
                                            className="icon"
                                        />
                                    </span>
                                    <div>
                                        <span className="mb-2 fw-medium text-secondary-light text-sm">
                                            Total Active Company
                                        </span>
                                        <h6 className="fw-semibold">
                                            {loading ? (
                                                <div className="spinner-border spinner-border-sm text-success" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            ) : (
                                                metrics.total_active_companies.toLocaleString()
                                            )}
                                        </h6>
                                    </div>
                                </div>
                                <div
                                    id="total-sales-chart"
                                    className="remove-tooltip-title rounded-tooltip-value"
                                >
                                    {/* Pass the color value here */}
                                    {createChart('#f4941e')}
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>

                <div className="col-xxl-4 col-sm-6">
                    <div className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-4">
                        <div className="card-body p-0">
                            <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                                <div className="d-flex align-items-center gap-2">
                                    <span className="mb-0 w-48-px h-48-px bg-purple text-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                                        <Icon icon="mdi:message-text" className="icon" />
                                    </span>
                                    <div>
                                        <span className="mb-2 fw-medium text-secondary-light text-sm">
                                            Total Max Employees
                                        </span>
                                        <h6 className="fw-semibold">
                                            {loading ? (
                                                <div className="spinner-border spinner-border-sm text-success" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            ) : (
                                                metrics.total_max_employees.toLocaleString()
                                            )}
                                        </h6>
                                    </div>
                                </div>
                                <div
                                    id="conversion-user-chart"
                                    className="remove-tooltip-title rounded-tooltip-value"
                                >
                                    {/* Pass the color value here */}
                                    {createChart('#8252e9')}
                                </div>
                            </div>
                            
                            
                        </div>
                    </div>
                </div>

                <div className="col-xxl-4 col-sm-6">
                    <div className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-5">
                        <div className="card-body p-0">
                            <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                                <div className="d-flex align-items-center gap-2">
                                    <span className="mb-0 w-48-px h-48-px bg-pink text-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                                        <Icon icon="mdi:leads" className="icon" />
                                    </span>
                                    <div>
                                        <span className="mb-2 fw-medium text-secondary-light text-sm">
                                            Total Max Users
                                        </span>
                                        <h6 className="fw-semibold">
                                            {loading ? (
                                                <div className="spinner-border spinner-border-sm text-success" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            ) : (
                                                metrics.total_max_users.toLocaleString()
                                            )}
                                        </h6>
                                    </div>
                                </div>
                                <div
                                    id="leads-chart"
                                    className="remove-tooltip-title rounded-tooltip-value"
                                >
                                    {/* Pass the color value here */}
                                    {createChart('#de3ace')}
                                </div>
                            </div>
                           
                        </div>
                    </div>
                </div>
                
                {/* CustomerCountCard */}
                {/* <CustomerCountCard /> */}
                <div className="col-xxl-4 col-sm-6">
                    <div className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-6">
                        <div className="card-body p-0">
                            <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                                <div className="d-flex align-items-center gap-2">
                                    <span className="mb-0 w-48-px h-48-px bg-danger-600 flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6 mb-0">
                                        <Icon
                                            icon="mingcute:user-3-fill"
                                            className="icon"
                                        />
                                    </span>
                                    <div>
                                        <span className="mb-2 fw-medium text-secondary-light text-sm">
                                            Total Max Companies
                                        </span>
                                        <h6 className="fw-semibold">
                                            {loading ? (
                                                <div className="spinner-border spinner-border-sm text-primary" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            ) : (
                                                metrics.total_max_companies.toLocaleString()
                                            )}
                                        </h6>
                                    </div>
                                </div>
                                <div
                                    id="customer-count-chart"
                                    className="remove-tooltip-title rounded-tooltip-value"
                                >
                                    {createChart('#dc2626')}
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UnitCountTwo
